var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"component-background-audio-check"}},[_c('b-card',{staticStyle:{"border":"none"}},[_c('b-spinner',{staticStyle:{"width":"5rem","height":"5rem"},attrs:{"id":"audio-check-spinner"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }